const footerLinks = [
  { name: '常见问答', href: '#faq' },
  { name: '平台介绍', href: '#about' },
  { name: '焦点专题', href: '#carousel' },
  { name: '热门话题', href: '#topics' },
  { name: '联系我们', href: '#contact' },
  { name: '热门榜单', href: '#ranking' },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="lg:col-span-2">
              <span className="font-heading text-xl md:text-2xl font-bold text-white">51大赛</span>
              <p className="mt-3 text-sm text-background-300 leading-relaxed max-w-md">
                51大赛是国内领先的赛事攻略与资源平台，提供海量51大赛视频、图片合集与深度攻略内容。每日更新最新赛事资源，助您一站式获取全部精彩内容。
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-white text-sm mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                {footerLinks.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-background-300 hover:text-white transition-colors cursor-pointer"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-white text-sm mb-4">合作伙伴</h4>
              <p className="text-sm text-background-400 leading-relaxed">
                更多合作伙伴即将加入，敬请期待。
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} 51大赛. 本站内容仅供学习交流使用。
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-background-400 hover:text-white transition-colors cursor-pointer">
                返回顶部
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}